import { Link, Outlet } from 'react-router-dom';
import { Aperture } from 'lucide-react';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-0 px-4 py-12 text-fg">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center text-center">
          <Aperture size={32} className="mb-4 text-fg" aria-hidden="true" />
          <span className="font-display text-3xl font-semibold tracking-tight text-fg">Zaslonka</span>
          <p className="mt-1.5 text-sm text-fg-secondary">Platforma za fotografska tekmovanja</p>
        </div>
        <div className="animate-slide-up rounded-card border border-line bg-surface-1 p-6 sm:p-7">
          <Outlet />
        </div>
        <p className="mt-4 text-center text-sm text-fg-muted">
          <Link to="/navodila-za-uporabo" className="hover:text-fg hover:underline">
            Navodila za uporabo
          </Link>
        </p>
      </div>
    </div>
  );
}
